import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { Fragment, useRef, useState } from 'react';
import { Bubble, Button, Card, Justify, Radio, Segment, Select } from 'tea-component';
import Active from '@sg/assests/images/CardActive.svg';
import Inertia from '@sg/assests/images/CardInertia.svg'
import './index.scss';
import { useIntl } from 'umi';
// import NoDataCommon from '../NoDataCommon';
// import LoadingCommon from '../LoadingCommon';
import { buriedCardBtnPoint } from '@op/operationLog/buriedPoint';
import CommonBubble from '@home/components/CommonBubble';
import RadioLeft from '@sg/assests/images/RadioLeft.svg';

type filterType = {
  text: string | JSX.Element;
  value: string;
  children?: {
    text: string;
    value: string;
  }[];
};

export type CardCommonType = {
  title?: string | JSX.Element; // 标题，字符串和 JSX 都可以
  operation?: string | JSX.Element; // 标题，字符串和 JSX 都可以
  children?: string | JSX.Element | Array<JSX.Element>; // 插入内容
  hasTitleArrow?: boolean; // 如果需要左边右边箭头可以点击去的 true ，默认false， 可以不传
  handleTitleOnClick?: () => void; // 标题点击事件
  cardHeaderElement?: JSX.Element;

  hasDownload?: boolean; // 是否展示下载  默认flase不展示
  handleDownloadOnClick?: () => void; // 下载 点击事件
  downloadIcon?: string;
  downLoadTips?: string;

  subFilterClassName?: string;
  subFilterBeforeElement?: JSX.Element;
  alwaysShowOperations?: boolean;
  operationInfo?: [string, (value: any) => void];
  defaultOperation?: string; // 默认点亮的操作

  className?: string; // 添加额外的类名

  filters?: filterType[]; // 筛选，要支持两级
  filterClassName?: string;
  filterInfo?: [string, (value: any) => void];
  handleFilterOnChange?: (value: string) => void;
  handleSubFilterOnChange?: (value: string) => void;

  // contentCard?: boolean; // 是否为内容卡片，有另外一套样式
  // dropdownsFilterBeforeElement?: JSX.Element;
  // dropdowns?: dropdown[]; // 下拉操作
  // defaultDropDown?: string; // 默认的下拉操作选项
  // dropdownFooter?: string | JSX.Element;
  // handleDropdownOnChange?: (item: dropdown) => void; // 统一的下拉点击事件

  bodyStyle?: React.CSSProperties;

  keepFiltersSpace?: boolean; // 是否保留筛选器的位置
  keepFiltersSpaceHeight?: number; // 保留筛选器的位置的高度
  keepSubFiltersSpace?: boolean; // 是否保留子筛选器
  keepSubFiltersSpaceHeight?: number; // 是否子筛选器的高度

  // loading 和 空白占位 统一处理

  loading?: boolean; // 是否在加载中
  loadingHeight?: number | string; // 加载状态高度
  loadingExt?: any; // loading 额外元素
  loadingText?: string;

  empty?: boolean;
  emptyHeight?: number | string;
  hasEmptyImg?: boolean;
  hasEmptyTitle?: boolean;
  hasEmptyDesc?: boolean;

  emptyTitleText?: string;
  emptyDescText?: string | React.ReactNode;
  emptyDescElement?: any;
  logBtnId?: string;
  extraInfo?: string | { [key: string]: any };
  [key: string]: any;
  otherSelectProps?: any;

  isActive?: number;

  // Edit mode functionality
  hasEditMode?: boolean; // 是否启用编辑模式
  canEdit?: boolean; // 用户是否有编辑权限
  isEditing?: boolean; // 当前是否处于编辑状态
  onEdit?: () => void; // 点击编辑按钮的回调
  onSave?: () => void | Promise<void>; // 点击保存按钮的回调
  onCancel?: () => void; // 点击取消按钮的回调
  headerClassName?: string; // 自定义header样式
};

/**
 * TODO: 其他系统使用
 * Tea组件卡片组件封装
 * @param props
 * @returns
 */
export default function CardCommon(props: CardCommonType) {
  const { formatMessage } = useIntl();
  const cardRef = useRef<HTMLDivElement>(null);
  const {
    title,
    operation,
    className,
    bodyStyle,
    children,
    isActive,
    cardKey,
    // Edit mode props
    hasEditMode = false,
    canEdit = false,
    isEditing = false,
    onEdit,
    onSave,
    onCancel,
    headerClassName = '',
    ...otherProps
  } = props;

  // Render edit mode header
  const renderEditModeHeader = () => {
    if (!hasEditMode) return null;

    return (
      <div className={`dbs-card-edit-header ${headerClassName}`}>
        <div className="dbs-card-title-wrapper">
          {title && <h3 className="dbs-card-titles">{title}</h3>}
        </div>
        {canEdit && !isEditing && (
          <Button
            onClick={onEdit}
            style={{ height: '30px', minWidth: '60px' }}
            className="dbs-gradient-btn"
          >
            {formatMessage({ id: 'dbs_edit' })}
          </Button>
        )}
        {canEdit && isEditing && (
          <div className="dbs-edit-buttons-wrapper">
            <Button
              onClick={onSave}
              style={{ height: '30px', minWidth: '76px' }}
              className="dbs-gradient-btn"
            >
              {formatMessage({ id: 'dbs_confirm' })}
            </Button>
            <Button
              onClick={onCancel}
              style={{ height: '30px', minWidth: '76px' }}
              className="dbs-outline-btn"
            >
              {formatMessage({ id: 'dbs_cancel' })}
            </Button>
          </div>
        )}
      </div>
    );
  };

  // Clone operation element to pass cardRef for chart download functionality
  const clonedOperation = React.isValidElement(operation)
    ? React.cloneElement(operation as React.ReactElement<any>, {
      cardRef: cardRef,
    })
    : operation;

  const RenderCard = (
    <Card
      ref={cardRef}
      className={`dbs-card-common card-common card-slot ${className} ${isActive && isActive === 1 ? `card-common-Active card-common-Active${cardKey}` : 'card-common-Inactive'}`}
      {...otherProps}
    >
      {
        isActive ? <div className={`card-common-action`}>
          <img src={isActive === 1 ? Active : Inertia} alt="" />
        </div> : <></>
      }
      <Card.Body
        style={{ ...bodyStyle }}
        title={
          hasEditMode ? undefined : (title && (<span>{title}</span>))
        }
        operation={hasEditMode ? undefined : clonedOperation}
      >
        {renderEditModeHeader()}
        {children}
        {/* {loading ? (
            <LoadingCommon
              status="loading"
              loadingExt={loadingExt}
              loadingText={loadingText}
              style={{ height: loadingHeight }}
            ></LoadingCommon>
          ) : empty ? (
            <NoDataCommon
              hasDesc={hasEmptyDesc}
              hasImg={hasEmptyImg}
              hasTitle={hasEmptyTitle}
              style={{
                height: emptyHeight,
              }}
              emptyTitleText={emptyTitleText}
              emptyDescText={emptyDescText}
              emptyDescElement={emptyDescElement}
            ></NoDataCommon>
          ) : (
            children
          )} */}
        <div className="card-common-action-line"></div>
        <div className={`card-common-action-raido card-common-action-raido${cardKey}`}>
          <img src={RadioLeft} alt="" />
        </div>
      </Card.Body>
    </Card>
  );
  return RenderCard;
}
